function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

import { elapsed, getPathName, isValidUrl, ResourceType, toServerDuration, isIntakeUrl, isExperimentalFeatureEnabled, ExperimentalFeature } from '@datadog/browser-core';
export var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [[ResourceType.DOCUMENT, function (initiatorType) {
  return FAKE_INITIAL_DOCUMENT === initiatorType;
}], [ResourceType.XHR, function (initiatorType) {
  return 'xmlhttprequest' === initiatorType;
}], [ResourceType.FETCH, function (initiatorType) {
  return 'fetch' === initiatorType;
}], [ResourceType.BEACON, function (initiatorType) {
  return 'beacon' === initiatorType;
}], [ResourceType.CSS, function (_, path) {
  return /\.css$/i.test(path);
}], [ResourceType.JS, function (_, path) {
  return /\.js$/i.test(path);
}], [ResourceType.IMAGE, function (initiatorType, path) {
  return ['image', 'img', 'icon'].includes(initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
}], [ResourceType.FONT, function (_, path) {
  return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null;
}], [ResourceType.MEDIA, function (initiatorType, path) {
  return ['audio', 'video'].includes(initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
}]];
export function computeResourceEntryType(entry) {
  var url = entry.name;

  if (!isValidUrl(url)) {
    return ResourceType.OTHER;
  }

  var path = getPathName(url);

  var _iterator = _createForOfIteratorHelper(RESOURCE_TYPES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          type = _step$value[0],
          isType = _step$value[1];

      if (isType(entry.initiatorType, path)) {
        return type;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return ResourceType.OTHER;
}

function areInOrder() {
  for (var i = 1; i < arguments.length; i += 1) {
    if ((i - 1 < 0 || arguments.length <= i - 1 ? undefined : arguments[i - 1]) > (i < 0 || arguments.length <= i ? undefined : arguments[i])) {
      return false;
    }
  }

  return true;
}

export function isResourceEntryRequestType(entry) {
  return entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch';
}
export function computeResourceEntryDuration(entry) {
  var duration = entry.duration,
      startTime = entry.startTime,
      responseEnd = entry.responseEnd; // Safari duration is always 0 on timings blocked by cross origin policies.

  if (duration === 0 && startTime < responseEnd) {
    return elapsed(startTime, responseEnd);
  }

  return duration;
}
export function computeResourceEntryDetails(entry) {
  if (!hasValidResourceEntryTimings(entry)) {
    return undefined;
  }

  var startTime = entry.startTime,
      fetchStart = entry.fetchStart,
      workerStart = entry.workerStart,
      redirectStart = entry.redirectStart,
      redirectEnd = entry.redirectEnd,
      domainLookupStart = entry.domainLookupStart,
      domainLookupEnd = entry.domainLookupEnd,
      connectStart = entry.connectStart,
      secureConnectionStart = entry.secureConnectionStart,
      connectEnd = entry.connectEnd,
      requestStart = entry.requestStart,
      responseStart = entry.responseStart,
      responseEnd = entry.responseEnd;
  var details = {
    download: formatTiming(startTime, responseStart, responseEnd),
    first_byte: formatTiming(startTime, requestStart, responseStart)
  }; // Make sure a worker processing time is recorded

  if (0 < workerStart && workerStart < fetchStart) {
    details.worker = formatTiming(startTime, workerStart, fetchStart);
  } // Make sure a connection occurred


  if (fetchStart < connectEnd) {
    details.connect = formatTiming(startTime, connectStart, connectEnd); // Make sure a secure connection occurred

    if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) {
      details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
    }
  } // Make sure a domain lookup occurred


  if (fetchStart < domainLookupEnd) {
    details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
  } // Make sure a redirection occurred


  if (startTime < redirectEnd) {
    details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
  }

  return details;
}
/**
 * Entries with negative duration are unexpected and should be dismissed. The intake will ignore RUM
 * Resource events with negative durations anyway.
 * Since Chromium 128, more entries have unexpected negative durations, see
 * https://issues.chromium.org/issues/363031537
 */

export function hasValidResourceEntryDuration(entry) {
  return entry.duration >= 0;
}
export function hasValidResourceEntryTimings(entry) {
  // Ensure timings are in the right order. On top of filtering out potential invalid
  // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
  // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
  // it.
  var areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
  var areRedirectionTimingsInOrder = hasRedirection(entry) ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
  return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}

function hasRedirection(entry) {
  return entry.redirectEnd > entry.startTime;
}

function formatTiming(origin, start, end) {
  if (origin <= start && start <= end) {
    return {
      duration: toServerDuration(elapsed(start, end)),
      start: toServerDuration(elapsed(origin, start))
    };
  }
}
/**
 * The 'nextHopProtocol' is an empty string for cross-origin resources without CORS headers,
 * meaning the protocol is unknown, and we shouldn't report it.
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/nextHopProtocol#cross-origin_resources
 */


export function computeResourceEntryProtocol(entry) {
  return entry.nextHopProtocol === '' ? undefined : entry.nextHopProtocol;
}
/**
 * Handles the 'deliveryType' property to distinguish between supported values ('cache', 'navigational-prefetch'),
 * undefined (unsupported in some browsers), and other cases ('other' for unknown or unrecognized values).
 * see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
 */

export function computeResourceEntryDeliveryType(entry) {
  return entry.deliveryType === '' ? 'other' : entry.deliveryType;
}
export function computeResourceEntrySize(entry) {
  // Make sure a request actually occurred
  if (entry.startTime < entry.responseStart) {
    var encodedBodySize = entry.encodedBodySize,
        decodedBodySize = entry.decodedBodySize,
        transferSize = entry.transferSize;
    return {
      size: decodedBodySize,
      encoded_body_size: encodedBodySize,
      decoded_body_size: decodedBodySize,
      transfer_size: transferSize
    };
  }

  return {
    size: undefined,
    encoded_body_size: undefined,
    decoded_body_size: undefined,
    transfer_size: undefined
  };
}
export function isAllowedRequestUrl(url) {
  return url && (!isIntakeUrl(url) || isExperimentalFeatureEnabled(ExperimentalFeature.TRACK_INTAKE_REQUESTS));
}
var DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
export var MAX_RESOURCE_VALUE_CHAR_LENGTH = 24000;
export function sanitizeIfLongDataUrl(url) {
  var lengthLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_RESOURCE_VALUE_CHAR_LENGTH;

  if (url.length <= lengthLimit || !url.startsWith('data:')) {
    return url;
  } // truncate url first to a random length to prevent match error when the url is too long


  var dataUrlMatchArray = url.substring(0, 100).match(DATA_URL_REGEX);

  if (!dataUrlMatchArray) {
    return url;
  }

  return "".concat(dataUrlMatchArray[0], "[...]");
}